module.exports = __webpack_public_path__ + "img/new_castelatto.045adb43.png";